













































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { hiddenDangerLibraryServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象

  // 表单数据
  formData: any = {};

  formRules: any = {};
  imgPath: any = publishObjectPath.imgPathWater;

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取隐患详情数据
    this.getDetailByIdData();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    hiddenDangerLibraryServer
      .getHazardManageDetail(this.row.id)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  getLevel(data: any) {
    if (data === 'A') {
      return '重大隐患(A)';
    }
    if (data === 'B') {
      return '一般隐患I级(B)';
    }
    if (data === 'C') {
      return '一般隐患II级(C)';
    }
    if (data === 'D') {
      return '一般隐患III级(D)';
    }
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.imgPath}${item.path}`);
    });
    return arr;
  }
}
